const translation: Record<string, string> = {
    // error view
    e0001: "돌아가기",
    e0002: "403 페이지에 접근할 수 없습니다.",
    e0003: "404 페이지를 찾을 수 없습니다.",
    e0004: "{code} 현재 서비스를 이용할 수 없습니다.",

    // base words
    b0000_ko: "한국어",
    b0000_en: "English",
    b0001: "확인",
    b0002: "취소",
    b0003: "닫기",
    b0004: "업로드",
    b0005: "다운로드",
    b0006: "삭제",
    b0007: "저장",
    b0008: "등록",
    b0009: "추가",
    b0010: "검색 결과가 없습니다.",
    b0011: "성공",
    b0012: "실패",
    b0013: "데이터가 없습니다.",
    b0014: "시나리오",
    b0015: "템플릿",
    b0016: "모두 펴기",
    b0017: "모두 접기",
    b0018: "펴기",
    b0019: "접기",
    b0020: "선택하세요",
    b0021: "이름",
    b0022: "배경",
    b0023: "버튼",
    b0024: "웹챗",
    b0025: "언어",
    b0026: "원형",
    b0027: "사각형",
    b0028: "왼쪽",
    b0029: "오른쪽",
    b0030: "기본",
    b0031: "기타",
    b0032: "통계",
    b0033: "동작",
    b0034: "자동완성",
    b0035: "키",
    b0036: "타이틀",
    b0037: "값",
    b0038: "질문",
    b0039: "답변",
    b0040: "FAQ",
    b0041: "상수",
    b0042: "초기화",
    b0043: "카카오톡",
    b0044: "네이버톡",
    b0045: "라인",
    b0046: "페이스북",
    b0047: "슬랙",
    b0048: "잔디",
    b0049: "인스타그램",
    b0050: "시나리오명",
    b0051: "소유자",
    b0052: "이미지",
    b0053: "모양",
    b0054: "텍스트",
    b0055: "캐러셀",
    b0056: "메세지",
    b0057: "적음",
    b0058: "많음",
    b0059: "아이콘",
    b0060: "홈",
    b0061: "퀵리플라이",
    b0062: "복사",
    b0063: "메뉴",
    b0064: "이전",
    b0065: "다음",

    // toast words
    t001: "등록을 완료했습니다.",
    t002: "등록 실패",
    t003: "수정을 완료했습니다.",
    t004: "수정 실패",
    t005: "삭제를 완료했습니다.",
    t006: "삭제 실패",
    t007: "다운로드에 실패했습니다.",

    // agent sidebar menu name
    m01: "대시보드",
    m02: "시나리오",
    m03: "템플릿",
    m04: "벌크테스트",
    m05: "배포",
    m06: "대화 이력",
    m07: "챗봇 연동",
    m08: "설정",
    m09: "멤버관리",

    // Component & Layout
    i00001: "시나리오 목록 보기",
    i00002: "샘플 파일 받기",
    i00003: "업로드 파일 형식은 엑셀만 지원됩니다.",
    i00003_1: "이곳에 파일을 놓거나 ",
    i00003_2: "파일을 선택",
    i00003_3: "하세요.",
    i00004: "엑셀파일(xls,xlsx)만 첨부하실 수 있습니다.",
    i00005: "파일은 용량은 20MB 이하여야합니다.",
    i00006: "파일 등록에 실패했습니다. 다시 시도하거나 다른 파일을 사용해 주세요.",
    i00007: "업로드 작업을 시작합니다.",
    i00008: "파일 업로드 중 에러가 발생했습니다.",
    i00009: "{total}개 중 {current}",
    i00010: "페이지",
    i00011: "개인정보 설정",
    i00012: "비밀번호 변경",
    i00013: "업로드",
    i00014: "로그아웃",
    i00015: "관리자",
    i00016: "멤버",
    i00017: "조회 기간은 {max}일 이내로 설정해주세요.",
    i00018: "검색어를 입력하세요.",
    i00019: "시나리오명 또는 소유자 이름으로 검색하세요.",
    i00020: "원본 보기",
    i00021: "다른 사용자가 접속중입니다.\n"
        + "저장 시 다른 사용자의 변경 내용이 덮어질 수도 있습니다.",
    i00022: "파일은 1개만 업로드 가능합니다.",
    i00023: "시나리오 추가",
    i00024: "시나리오명을 입력하세요.",
    i00025: "시나리오 설명",
    i00026: "시나리오 설명을 입력하세요.",
    i00027: "변경일시",
    i00028: "생성일시",
    i00029: "미래의 날짜는 선택할 수 없습니다.",
    i00030: "날짜 형식이 올바르지 않습니다. yyyy.mm.dd hh:mm AM/PM 형식으로 입력해주세요.",
    i00030_1: "날짜 형식이 올바르지 않습니다. yyyy.mm.dd형식으로 입력해주세요.",
    i00031: "조회 기간은 {min}일 이상으로 설정해주세요.",
    i00032: "표시할 항목이 없습니다.\n"
        + "'설정 > NLU > NLU 에이전트' 설정을 확인해주세요.",
    i00033: "편집 안내",
    i00034: "표시할 항목이 없습니다.",
    i00035: "파일 업로드 에러",
    i00036: "{fileName} 파일은 업로드가 불가능한 파일입니다.",
    i00037: "기간 선택",

    // Dashboard
    i01001: "7일",
    i01002: "1개월",
    i01003: "3개월",
    i01004: "사용자",
    i01005: "세션",
    i01006: "세션 평균 메세지",
    i01007: "YYYY년 MM월 DD일",
    i01008: "현황",
    i01009: "요일별 평균 메시지",
    i01010: "조회 기간 중 요일별 평균 수치입니다.\n"
        + "매우 많음 (상위 0~20%)\n"
        + "많음 (상위 20~40%)\n"
        + "중간 (상위 40~60%)\n"
        + "적음 (상위 60~80%)\n"
        + "아주 적음 (상위 80~100%)",
    i01011: "인텐트 랭킹",
    i01012: "미분류",
    i01013: "메시지 피드백",
    i01014: "전체 메시지 기준",
    i01015: "좋아요",
    i01016: "싫어요",
    i01017: "{hour}시",
    i01018: "피드백이 없습니다.",
    i01021_1: "하위 100% ~ 80%",
    i01021_2: "하위 80% ~ 60%",
    i01021_3: "중위 60% ~ 40%",
    i01021_4: "상위 40% ~ 20%",
    i01021_5: "상위 20% ~ 0%",

    // Scene Editor
    i02001: "씬 추가",
    i02002: "대화 테스트",
    i02003: "씬 또는 패러그래프의 ID, 이름, 조건, 데이터 등으로 검색하세요.",
    i02004: "씬 ID",
    i02005: "씬 ID를 입력하세요.",
    i02006: "씬 이름",
    i02007: "씬 이름을 입력하세요.",
    i02008: "웰컴",
    i02009: "폴백",
    i02010: "웰컴씬으로",
    i02011: "폴백씬으로",
    i02012: "씬 삭제",
    i02013: "삭제한 씬은 복구가 불가능합니다.\n삭제 하시겠습니까?",
    i02014: "씬 ID",
    i02015: "씬 이름",
    i02016: "우선 순위",
    i02017: "사용자 쿼리에 대한 응답을 찾을 때 진입조건에 매칭되는 씬이 여러개 있는 경우 우선순위가 높은 씬을 답변으로 제공합니다.\n"
        + "0부터 9999까지의 숫자로 클수록 우선순위가 높습니다.",
    i02018: "진입 조건",
    i02019: "사용자가 메시지를 입력 시 이 씬에 진입하도록 하는 조건을 설정합니다.\n"
        + "and, or, (, ), ==, != 등의 조건문을 사용할 수 있습니다.\n"
        + "# 입력: 인텐트 목록\n"
        + "@ 입력: 엔티티 목록\n"
        + "$ 입력: 사용가능한 변수, 상수 목록",
    i02020: "파일을 업로드해주세요.",
    i02021: "씬 복사",
    i02022: "연동 설정",
    i02023: "시나리오 설정",
    i02024: "씬 ID는 유일한 값이어야 합니다.",
    i02025: "시나리오 엑셀파일에 오류가 있습니다.",
    i02026: "시나리오 엑셀파일 확인이 필요합니다.",
    i02027: "씬을 추가해 시나리오를 작성하세요.",
    i02028: "복제된 씬이 존재합니다.",

    // Template Editor
    i03001: "템플릿 추가",
    i03002: "템플릿 이름",
    i03003: "이름을 입력하세요.",
    i03004: "템플릿 또는 패러그래프의 이름, 조건, 데이터 등으로 검색하세요.",
    i03005: "템플릿 복사",
    i03006: "템플릿 삭제",
    i03007: "템플릿 이름은 유일한 값이어야 합니다.",
    i03008: "템플릿을 추가해주세요.",
    i03009: "복제된 템플릿이 존재합니다.",
    i03010: "템플릿 메뉴",

    // Paragraph Editor
    i04001: "패러그래프 설정",
    i04002: "패러그래프 추가",
    i04003: "템플릿으로 이동하여 편집",
    i04004: "템플릿으로 만들기",
    i04005: "사본 생성",
    i04006: "데이터 유형",
    i04007: "수행 조건",
    i04008: "패러그래프 조건이 필요한 경우 사용하세요.",
    i04009: "맨 위로",
    i04010: "맨 아래로",
    i04011: "위로",
    i04012: "아래로",
    i04013: "버튼 선택시 전송할 텍스트.",
    i04013_1: "전송할 텍스트.",
    i04014: "텍스트 전송",
    i04015: "다음으로 이동",
    i04016: "링크 열기",
    i04017: "이전으로 돌아가기",
    i04017_1: "이전 씬으로",
    i04018: "다른 시나리오로 동작",
    i04018_1: "다른 시나리오",
    i04019: "모바일 링크를 입력하세요. (기본)",
    i04019_1: "모바일 링크 (기본)",
    i04020: "PC 링크를 입력하세요.",
    i04020_1: "PC 링크",
    i04021: "추가 정보를 입력하세요.",
    i04022: "사용자 입력으로 보낼 쿼리를 입력하세요.",
    i04022_1: "사용자 입력 쿼리",
    i04023: "씬 이동할 때 변수를 설정할 수 있습니다.",
    i04024: "다음 씬 이동 조건",
    i04025: "이동할 씬을 선택하세요.",
    i04025_1: "이동할 씬 선택",
    i04026: "시나리오를 선택하세요.",
    i04026_1: "시나리오 선택",
    i04027: "변수의 키 값을 입력하세요.",
    i04027_1: "키 입력",
    i04028: "변수로 저장할 값을 입력하세요.",
    i04028_1: "값 입력",
    i04029: "버튼 설정",
    i04030: "카드 설정",
    i04031: "변수 설정",
    i04032: "커스텀 데이터 설정",
    i04033: "JSON 형식으로 입력해주세요.",
    i04034: "다운로드 데이터 설정",
    i04035: "파일 URL을 입력하세요.",
    i04036: "미디어 URL을 입력하세요.",
    i04037: "다운로드 버튼 라벨을 입력하세요",
    i04038: "파일에 대한 설명을 입력하세요.",
    i04039: "타이틀을 입력하세요.",
    i04040: "본문을 입력하세요.",
    i04041: "변경사항 확인",
    i04042: "변경된 패러그래프가 있습니다.\n저장하지 않고 다른 메뉴로 이동할까요?",
    i04043: "변수 설정 열기",
    i04044: "미디어 설정",
    i04045: "디폴트",
    i04046: "에러",
    i04047: "메시지를 추가해주세요.",
    i04048: "메세지 유형",
    i04049: "변수를 추가해주세요.",
    i04050: "메세지를 입력하세요.",
    i04051: "API URL을 입력하세요.",
    i04052: "HTTP 헤더",
    i04053: "헤더 키를 입력하세요.",
    i04054: "헤더 값을 입력하세요.",
    i04055: "파라미터 설정",
    i04056: "파라미터 키를 입력하세요.",
    i04057: "파라미터 값을 입력하세요.",
    i04058: "Body(JSON)",
    i04059: "디폴트",
    i04060: "스트림",
    i04061: "GET",
    i04062: "POST",
    i04063: "PUT",
    i04064: "DELETE",
    i04065: "Mode",
    i04066: "HTTP 메소드",
    i04067: "URL",
    i04068: "코드 설정",
    i04069: "시나리오 템플릿 설정",
    i04070: "버튼명을 입력하세요.",
    i04071: "키보드 입력 방지",
    i04072: "입력 메시지 마스킹 처리",
    i04073: "미디어, 타이틀, 본문 중 한가지는 필수로 입력해야합니다.",
    i04074: "템플릿을 선택해주세요.",
    i04075: "버튼명",
    i04076: "다음 씬 이동 조건을 입력하세요.",
    i04077: "올바른 URL 또는 변수를 입력해주세요.",
    i04078: "인텐트 사용",
    i04079: "답변 출처",
    i04080: "추천 질의",
    i04081: "버튼을 추가해주세요.",
    i04082: "코드를 입력해주세요.",
    i04083: "현재 지원되지 않는 패러그래프 타입입니다.",
    i04084: "출처명",
    i04085: "이전 달",
    i04086: "다음 달",
    i04087: "메인 내비게이션",
    i04088: "앱 메뉴",
    i04089: "페이지 번호",
    i04090: "단락 작업",
    i04091: "단락 순서 이동",
    i04092: "페이지 탐색",
    i04093: "추가 정보",

    //Bulk Test
    i05001: "테스트 등록",
    i05002: "테스트명",
    i05003: "테스트 파일명",
    i05004: "테스트 쿼리 수",
    i05005: "테스트 일시",
    i05006: "상태",
    i05007: "테스트명으로 검색하세요.",
    i05008: "A열에 테스트할 쿼리를 입력해주세요.",
    i05009: "테스트명을 입력하세요.",
    i05010: "엑셀파일에서 테스트 쿼리를 찾을 수 없습니다. 테스트 쿼리가 1열에 작성되었는지 확인해주세요.",
    i05011: "벌크 테스트를 취소했습니다.",
    i05012: "올바른 형식의 엑셀파일인지 확인해주세요.",
    i05013: "파일 업로드해주세요",
    i05014: "제목을 입력해주세요",
    i05015: "테스트 요청에 실패했습니다",

    //Deployment
    i06001: "변경 사항",
    i06002: "배포하기",
    i06003: "버전",
    i06004: "신규 버전",
    i06005: "이전 버전",
    i06006: "배포할 버전을 선택하세요",
    i06007: "버전",
    i06008: "작업일시",
    i06009: "작업자",
    i06010: "작업내용",
    i06011: "서비스 중",
    i06012: "시나리오 배포 기록이 없습니다.",
    i06013: "작업 내용",
    i06014: "작업 내용을 입력해주세요.",
    i06015: "변경 사항",
    i06016: "변경된 시나리오",
    i06017: "추가된 시나리오",
    i06018: "삭제된 시나리오",
    i06019: "변경된 시나리오 정보",
    i06020: "추가된 시나리오 정보",
    i06021: "삭제된 시나리오 정보",
    i06022: "변경된 템플릿",
    i06023: "추가된 템플릿",
    i06024: "삭제된 템플릿",
    i06025: "변경된 배포 정보",
    i06026: "추가된 배포 정보",
    i06027: "삭제된 배포 정보",
    i06028: "이미 배포된 시나리오입니다.",
    i06029: "현재 시나리오와 동일합니다.",
    i06030: "배포에 성공했습니다.",
    i06031: "배포에 실패했습니다.",
    i06032: "변경",
    i06033: "차이점이 없습니다.",
    i06034: "시나리오와 차이점",
    i06035: "직전 버전과 차이점",
    i06036: "현재 작성되어 있는 시나리오와의 차이점을 확인할 수 있습니다.",
    i06037: "직전 버전과의 차이점을 확인할 수 있습니다.",
    i06038: "차이 비교할 데이터가 없습니다.",
    
    // Conversation History
    i07001: "전체 메시지",
    i07002: "대화별 메시지",
    i07003: "검색할 메시지를 입력하세요.",
    i07004: "세션 키",
    i07005: "사용자 입력",
    i07006: "챗봇 응답",
    i07007: "답변 시간",
    i07008: "인텐트",
    i07009: "씬 이름",
    i07010: "사용자 키",
    i07011: "채널",
    i07012: "피드백",
    i07013: "세션 키를 복사했습니다.",
    i07014: "사용자 키를 복사했습니다.",
    i07015: "대화별 메시지는 세션 단위입니다.",
    i07016: "대화를 선택해 주세요.",

    // Integration
    i08001: "메신저",
    i08002: "연동 중",
    i08003: "웹 브라우저에서 동작하는 챗봇을 설정할 수 있습니다.",
    i08004: "카카오톡 오픈빌더와 연동하여 카카오톡으로 챗봇을 서비스할 수 있습니다.",
    i08005: "네이버톡특으로 챗봇을 서비스할 수 있습니다.",
    i08006: "라인 채널에서 챗봇을 서비스할 수 있습니다.",
    i08007: "페이스북 페이지에 챗봇을 서비스할 수 있습니다.",
    i08008: "슬랙 워크스페이스에서 챗봇을 서비스할 수 있습니다.",
    i08009: "잔디 대화방에서 챗봇을 서비스할 수 있습니다.",
    i08010: "인스타그램에서 챗봇을 서비스할 수 있습니다.",
    i08011: "URL이 복사되었습니다.",
    i08012: "곧 메뉴얼이 제공될 예정입니다.",

    // Integration Kakaotalk
    i08101: "연동 활성화",
    i08102: "응답 지연 시 사용할 메시지를 입력하세요.",
    i08103: "웰컴 스킬 URL",
    i08104: "폴백 스킬 URL",
    i08105: "Share URL",
    i08106: "메시지에서 HTML 태그 제거\n(성능 저하)",
    i08107: "AI 챗봇 모드",
    i08108: "응답 지연 메시지 발송 시간(초)",
    i08109: "응답 지연 메시지",
    i08110: "응답 지연시에 노출되는 메시지입니다.\n"
        + " ex) 답변을 찾고 있어요. 잠시 기다려 주세요.\n"
        + " ex) 메시지를 생성 중이에요. 잠시만 기다려 주세요.",
    i08111: "카카오톡 연동 메뉴얼",

    // Integration Webchat
    i09001: "레이아웃",
    i09002: "스타일",
    i09003: "배너",
    i09004: "웹챗 테마에 오류가 있습니다.",
    i09005: "이미 다른 시나리오에서 사용하고 있는 웹챗 주소 이름입니다.",
    i09006: "배너 버튼에 함께 표시될 텍스트를 입력해주세요.",
    i09007: "대화",
    i09008: "배너 미리보기",
    i09009: "미리보기",
    i09010: "챗봇명",
    i09011: "WebChat URL Alias",
    i09012: "파비콘",
    i09013: "백그라운드 이미지",
    i09014: "웹챗 접속 URL에 사용될 별칭입니다.",
    i09015: "영어 또는 숫자만 사용할 수 있습니다",
    i09016: "아바타",
    i09017: "대화창",
    i09018: "퀵 리플라이 전체 보기",
    i09019: "입력창",
    i09020: "메시지 전체보기 라인 수",
    i09021: "이미지가 있는 경우 챗봇명 보다 우선 노출됩니다.",
    i09022: "메시지 더보기를 사용하시려면 1보다 큰 수를 입력해주세요.\n0은 사용안함 설정입니다.",
    i09023: "메시지 텍스트 (px)",
    i09024: "캐러셀 타이틀 (px)",
    i09025: "버튼 텍스트 (px)",
    i09026: "버튼 텍스트 정렬",
    i09027: "메시지 전체보기",
    i09028: "10px ~ 20px 까지 입력해주세요.",
    i09029: "추가 설명",
    i09030: "(선택)",
    i09031: "캐러셀 버튼 텍스트 정렬",
    i09032: "캐러셀 버튼 모양",
    i09033: "플레이스 홀더",
    i09034: "무엇이든 물어보세요.",
    i09035: "자동완성 사용",
    i09036: "피드백 수집",
    i09037: "웰컴 메시지 스크롤 유지",
    i09038: "무엇을 도와드릴까요?",
    i09039: "인사말",
    i09040: "메인색 시작",
    i09041: "메인색 끝",
    i09042: "입력창 영역 배경",
    i09043: "입력창 배경",
    i09044: "입력 글자",
    i09045: "입력창 기본 문구",
    i09046: "전송 버튼",
    i09047: "입력창에 표시되는 안내 문구를 입력해주세요.",
    i09048: "하이라이트",
    i09049: "{maxLength}자 이하로 입력해 주세요.",
    i09050: "긍정 아이콘",
    i09051: "부정 아이콘",
    i09052: "글자",
    i09053: "테두리",
    i09054: "캐러셀",
    i09055: "글자",
    i09056: "배경",
    i09057: "테두리",
    i09058: "마우스 오버",
    i09059: "이동 화살표",
    i09060: "메세지 전체 보기",
    i09061: "버튼 텍스트",
    i09062: "팝업 내 확인 버튼 글자",
    i09063: "팝업 내 확인 버튼 배경",
    i09064: "팝업 내 확인 버튼 테두리",
    i09065: "사용자 말풍선",
    i09066: "배너 디자인",
    i09067: "배너 설치",
    i09068: "배너 아이콘",
    i09069: "배너 아이콘 이미지 모양",
    i09070: "배너 색상",
    i09071: "배너 텍스트",
    i09072: "배너 위치",
    i09073: "데스크탑",
    i09074: "모바일",
    i09075: "배너 정렬",
    i09076: "바닥에서(px)",
    i09077: "왼쪽에서(px)",
    i09078: "오른쪽에서(px)",
    i09079: "배너 크기",
    i09080: "삽입 코드를 복사했습니다.",
    i09081: "배너 표시 URL 화이트리스트",
    i09082: "화이트리스트로 등록할 URL 주소를 입력하세요.",
    i09083: "http://나 https://로 시작되는 주소로 입력하세요.",
    i09084: "등록된 화이트리스트가 없을 시 챗봇을 설치한 모든 웹페이지에서 챗봇 버튼이 나타납니다.",
    i09085: "• 화이트리스트를 등록하면, 해당 페이지에서만 노출됩니다.\n"
        + "• http://나 https://로 시작되는 주소로 입력하세요.\n"
        + "• 주소 뒤에 *을 추가하면 화이트리스트 시작하는 모든 페이지에 노출됩니다.\n"
        + "   (예시) https://example.com/*",
    i09086: "웹 사이트 삽입 코드",
    i09087: "이미 등록된 화이트리스트입니다.",
    i09088: "메시지 노출 지연시간(초)",
    i09089: "자동완성 노출 갯수",
    i09090: "퀵 메뉴",
    i09091: "버튼 설정",
    i09092: "최초 진입 시 자동 노출",
    i09093: "Dim 설정",
    i09094: "추천 질문",
    i09095: "추천 질문을 입력해주세요.",
    i09096: "이벤트 카드",
    i09097: "텍스트형",
    i09098: "아이콘형",
    i09099: "이미지형",
    i09100: "파트너십 배너",
    i09101: "홈화면 카드 설정",
    i09102: "이벤트명을 입력하세요.",
    i09103: "이동할 링크 URL을 입력하세요.",
    i09104: "이벤트 카드 노출일 설정",
    i09105: "이벤트 이미지",
    i09106: "둥글게",
    i09107: "비율대로",
    i09108: "이벤트",

    // Setting
    i10001: "NLU",
    i10002: "시나리오 삭제",
    i10003: "시나리오를 삭제하면 되돌릴 수 없습니다.\n신중하게 생각하고 결정하세요.\n삭제 하시겠습니까?",
    i10004: "Open API 토큰",
    i10005: "NLU 에이전트",
    i10006: "시나리오 NLU 에이전트를 선택해주세요",
    i10007: "JSON 형식이었던 값이 변경되었습니다. 값 형식에 주의해주세요.",
    i10007_1: " 등 {count}개",
    i10008: "NLU 결과 커스터마이징 (Python)",
    i10009: "표시할 수 없는 에이전트입니다",
    i10010: "자동완성에 사용할 설정을 선택하세요.",
    i10011: "사용 가능한 자동완성이 없습니다.",
    i10012: "시나리오 이름을 입력해주세요.",
    i10013: "시나리오 설명",
    i10014: "시나리오 설명을 입력하세요.",
    i10015: "시나리오 언어를 선택해주세요.",
    i10016: "Request API Timeout(초)",
    i10017: "대화 만료 시간(초)",
    i10018: "마지막 대화 복원 시간 (초)",
    i10019: "오류 메시지",
    i10020: "기본 오류 메시지를 입력하세요.",
    i10021: "지나간 대화 버튼 선택 시 변수 복원기능 사용",
    i10022: "디버그 메시지 보기",
    i10023: "http://나 https://로 시작되는 주소로 입력하세요.",
    i10024: "대화 이력 추가 필드",
    i10025: "context 삭제 목록",
    i10026: "context 삭제 필드",
    i10027: "Message Webhook",
    i10028: "Webhook url (POST)",
    i10029: "토큰 발급을 완료했습니다.",
    i10030: "토큰 발급에 실패했습니다.",
    i10031: "카테고리",
    i10032: "Open API 토큰은 새로 생성 시 ‘저장’ 버튼을 누르지 않아도 즉시 생성 및 적용 됩니다.",
    i10033: "토큰 재발급 시 기존 토큰은 즉시 사용이 불가합니다.",
    i10034: "Open API 토큰을 복사했습니다.",
    i10035: "토큰 보기",
    i10036: "토큰 숨기기",
    i10037: "토큰 복사",
    i10038: "토큰 갱신",

    //Member
    i11001: "멤버 추가",
    i11002: "소유자 변경",
    i11003: "아이디 또는 이름으로 검색하세요.",
    i11004: "아이디(이메일)",
    i11005: "소속",
    i11006: "유형",
    i11007: "변경 일시",
    i11008: "초대할 사용자의 이메일을 검색하세요.",
    i11009: "{username}님을 멤버로 등록했습니다.",
    i11010: "멤버 정보 수정",
    i11011: "아이디",
    i11012: "멤버 삭제",
    i11013: "삭제한 멤버는 시나리오 사용이 불가능합니다.\n삭제 하시겠습니까?",
    i11014: "멤버 수정",
    i11015: "계정 유형",
    i11016: "유효한 이메일 주소를 입력해주세요.",
    i11017: "시나리오의 소유자를 {username} 님으로 변경합니다.",
    i11018: "멤버 초대",
    i11019: "이메일",

};

export default translation;
